import React, { useState } from 'react';
import {Favorite, FavoriteBorder} from "@material-ui/icons";
import SwiperCore, { Navigation } from "swiper";
import { Link } from 'react-router-dom'
import "./Product.css";

function Product({data}) {
    SwiperCore.use([Navigation])
    
    const [liked, setLiked] = useState(false);

    return (
        <div id={`product_${data.id}`} className="product-card">
            <span className="logo">संम्सकृथि</span>
            <div className="heartIcon" onClick={() => setLiked(prev => !prev)}>
                { liked? <Favorite /> : <FavoriteBorder /> }
            </div>
            <div className="fc-image-container">
                <img src={ data.imageUrl1 } alt="Image" />

            </div>
            <div className="product-detail">
                <h2>{ data.name }</h2>
                <div className="details">
                    <div>QTY</div>
                    <div>Price</div>
                    <div>{ data.price[0].quantity }</div>
                    <div>₹ { data.price[0].value }</div>
                </div>
                <Link to={`/${data.name.split(" ").join("_")}`} className="buy">Buy Now</Link>
            </div>        
        </div>
    )
}

export default Product
